import axios from 'axios';
import Cookies from 'universal-cookie';
import { IS_LOCALHOST, API_ROOT, USER_PORT, config } from '../../configs/environments';
import CONSTANTS from '../../configs/constants';

const cookies = new Cookies();

const API = () => (
  {
    authUser: () => {
      if (!IS_LOCALHOST) {
        const ssoCookie = cookies.get(CONSTANTS.SSO_COOKIE_NAME);
        if (!ssoCookie) {
          return axios.get(`${API_ROOT}:${USER_PORT}/api/user/auth`, config)
            .then((response) => {
              if (response.status === 200) {
                window.location.href = response.headers['return-url'];
              } else {
                window.location.href = `/#/error-screen/${response.status ? response.status : ''}`;
              }
            })
            .catch((error) => {
              window.location.href = `/#/error-screen/${error.response && error.response.status ? error.response.status : ''}`;
            });
        }
      }

      return false;
    },
  }
);

export default API(axios);



// WEBPACK FOOTER //
// src/services/userService/api.js